export const FETCH_RESERVATIONS_REQUEST = 'FETCH_RESERVATIONS_REQUEST';
export const FETCH_RESERVATIONS_SUCCESS = 'FETCH_RESERVATIONS_SUCCESS';
export const FETCH_RESERVATIONS_FAILED = 'FETCH_RESERVATIONS_FAILED';

export const FETCH_RESERVATION_BY_ID_REQUEST = 'FETCH_RESERVATION_BY_ID_REQUEST';
export const FETCH_RESERVATION_BY_ID_SUCCESS = 'FETCH_RESERVATION_BY_ID_SUCCESS';
export const FETCH_RESERVATION_BY_ID_FAILED = 'FETCH_RESERVATION_BY_ID_FAILED';

export const FETCH_CREATE_RESERVATION_REQUEST = 'FETCH_UCREATERESERVATION_REQUEST';
export const FETCH_CREATE_RESERVATION_SUCCESS = 'FETCH_UCREATERESERVATION_SUCCESS';
export const FETCH_CREATE_RESERVATION_FAILED = 'FETCH_UCREATERESERVATION_FAILED';

export const FETCH_UPDATE_RESERVATION_REQUEST = 'FETCH_UPDATE_RESERVATION_REQUEST';
export const FETCH_UPDATE_RESERVATION_SUCCESS = 'FETCH_UPDATE_RESERVATION_SUCCESS';
export const FETCH_UPDATE_RESERVATION_FAILED = 'FETCH_UPDATE_RESERVATION_FAILED';

export const FETCH_RESERVATIONS_RULES_REQUEST = 'FETCH_RESERVATIONS_RULES_REQUEST';
export const FETCH_RESERVATIONS_RULES_SUCCESS = 'FETCH_RESERVATIONS_RULES_SUCCESS';
export const FETCH_RESERVATIONS_RULES_FAILED = 'FETCH_RESERVATIONS_RULES_FAILED';

export const START_RESERVATION_REQUEST = 'START_RESERVATION_REQUEST';
export const START_RESERVATION_SUCCESS = 'START_RESERVATION_SUCCESS';
export const START_RESERVATION_FAILED = 'START_RESERVATION_FAILED';

export const END_RESERVATION_REQUEST = 'END_RESERVATION_REQUEST';
export const END_RESERVATION_SUCCESS = 'END_RESERVATION_SUCCESS';
export const END_RESERVATION_FAILED = 'END_RESERVATION_FAILED';

export const CANCEL_RESERVATION_REQUEST = 'CANCEL_RESERVATION_REQUEST';
export const CANCEL_RESERVATION_SUCCESS = 'CANCEL_RESERVATION_SUCCESS';
export const CANCEL_RESERVATION_FAILED = 'CANCEL_RESERVATION_FAILED';

export const RESET_UPDATE_RESERVATION = 'RESET_UPDATE_RESERVATION';

export const FETCH_ADD_BROKER_REQUEST = 'FETCH_ADD_BROKER_REQUEST';
export const FETCH_ADD_BROKER_SUCCESS = 'FETCH_ADD_BROKER_SUCCESS';
export const FETCH_ADD_BROKER_FAILED = 'FETCH_ADD_BROKER_FAILED';

export const FETCH_REMOVE_BROKER_REQUEST = 'FETCH_REMOVE_BROKER_REQUEST';
export const FETCH_REMOVE_BROKER_SUCCESS = 'FETCH_REMOVE_BROKER_SUCCESS';
export const FETCH_REMOVE_BROKER_FAILED = 'FETCH_REMOVE_BROKER_FAILED';

export const FETCH_BUSINESS_HOURS_REQUEST = 'FETCH_BUSINESS_HOURS_REQUEST';
export const FETCH_BUSINESS_HOURS_SUCCESS = 'FETCH_BUSINESS_HOURS_SUCCESS';
export const FETCH_BUSINESS_HOURS_FAILED = 'FETCH_BUSINESS_HOURS_FAILED';

export const CHANGE_BULK_RESERVATIONS_STATUS_REQUEST = 'CHANGE_BULK_RESERVATIONS_STATUS_REQUEST';
export const CHANGE_BULK_RESERVATIONS_STATUS_SUCCESS = 'CHANGE_BULK_RESERVATIONS_STATUS_SUCCESS';
export const CHANGE_BULK_RESERVATIONS_STATUS_FAILED = 'CHANGE_BULK_RESERVATIONS_STATUS_FAILED';
export const RESET_BULK_RESERVATIONS_STATUS = 'RESET_BULK_RESERVATIONS_STATUS';
